import gql from 'graphql-tag';
import { ACCOUNT_CONTACT_FRAGMENT } from './fragment';

export const ACCOUNT_CONTACTS = gql`
  ${ACCOUNT_CONTACT_FRAGMENT}
  query AccountContacts($input: AccountContactsInput!) {
    accountQuery {
      contacts(input: $input) {
        success
        error
        list {
          ...AccountContactFields
        }
      }
    }
  }
`;
